import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ChatBox from "../../../components/Chat/ChatBox";
import { selectMessage, selectOpDetail } from '../../../util/store/selectors';
import { useSelector } from "../../../util/store/store";
import { CHAT_TYPE } from "../../../util/varibles/constants";
import { messageActions } from "../../MessagePage/reducer";
import styles from './style.module.scss';

interface IProps {
}

const Chat: React.FC<IProps> = () => {
    const data = useSelector(selectOpDetail.data);
    const { id, operation_code, operation_type, site_name, tenant_id } = data?.operation || {};
    const dispatch = useDispatch();
    const allMessages = useSelector(selectMessage.messages);
    const handleSend = useCallback((params: any) => {
        dispatch(messageActions.sendMessageRequest({
            ...params,
            type: CHAT_TYPE.OPERATION,
            group_id: id,
            group_chat: {
                id,
                field: CHAT_TYPE.OPERATION,
                site_name,
                name: operation_code,
                operation_type,
                tenant_id
            }
        }))
    }, [dispatch, id, operation_code, operation_type, site_name, tenant_id]);


    const { messages = [], prev: isMore = false, loading = false } = allMessages[id || ""] || {}
    return <div className={styles.chat}>
        <ChatBox
            data={{
                type: CHAT_TYPE.OPERATION,
                group_chat: { id, members: [] }
            }}
            messages={messages}
            loading={loading}
            isMore={isMore}
            onSend={handleSend}
        />
    </div>;
}

export default Chat
